<script>
  /**
   * 走行記録のレスポンシブ表示
   */
  import { DRIVE_REPORT_SCHEME } from '../scheme'
  import { formatDate } from './helpers'

  export let name
  export let report

  // スキーマから指定のフィールドを取り出す
  const pickField = (name) =>
    DRIVE_REPORT_SCHEME.filter((field) => field.name === name)[0]

  // 表示するカラムの指定
  //  スキーマそのままか、あるいは計算結果を表示するのか
  const columns = [
    { name: 'firstLine', label: '日付' },
    pickField('carNumber'),
    { name: 'odometer', label: 'メーター' },
    { name: 'fuelOil', label: '給油量' },
    pickField('memo'),
  ]

  // 計算列のフォーマッタ
  //  値がない場合は ? に置き換え、joinする
  const formatter = (values) =>
    values.map((value) => (value ? value : '?')).join(' ')

  // 計算列の計算
  $: computed = {
    ...report,

    firstLine: formatter([
      formatDate(report.date),
      report.weather,
      report.reporterName,
    ]),

    odometer: formatter([
      report.odometerStart
        ? Number(report.odometerStart).toLocaleString()
        : null,
      'km ～',
      report.odometerEnd ? Number(report.odometerEnd).toLocaleString() : null,
      'km (',
      report.odometerStart && report.odometerEnd
        ? Number(report.odometerEnd - report.odometerStart).toLocaleString()
        : null,
      'km)',
    ]),

    fuelOil: formatter([
      report.refuel ? `${report.refuel} ℓ` : '-',
      '/',
      report.odometerOil
        ? `オイル交換: ${Number(report.odometerOil).toLocaleString()} km`
        : '-',
    ]),
  }
</script>

<div class="columns" data-testid={`${name}`}>
  {#each columns as column, index}
    {@const value = computed[column.name]}
    <!-- 空の場合は非表示するフィールドを判別 -->
    {#if value || !column.hideEmpty}
      <!-- 管理者用フィールドはBG色を付けて表示 -->
      <div
        class="column"
        data-testid={`${name}Column${index}`}
        class:has-background-warning-light={column.isSecret}
      >
        <!-- ラベルや値を装飾しつつ表示 -->
        <span class="label">{column.label}:</span>
        <span class="value">{value ? value : ''}</span>
      </div>
    {/if}
  {/each}
</div>

<style>
  /* ラベルの装飾 */
  span.label {
    font-weight: lighter;
    display: inline;
  }
  /* 値の装飾 */
  span.value {
    font-weight: bolder;
    display: inline;
  }
</style>
